import { BugOutlined, LoadingOutlined } from "@ant-design/icons";
import { useMutation } from "@apollo/client";
import { FloatButton, Tooltip, message } from "antd";

import { AssetErrorTestDocument } from "../../graphql/graphql";
import { depromisify } from "../../utils/depromisify";

interface AssetErrorTestProps {
  assetId: string;
}

const AssetErrorTest = ({ assetId }: AssetErrorTestProps) => {
  const [mutation, { loading }] = useMutation(AssetErrorTestDocument);

  const handleTest = depromisify(async () => {
    const response = await mutation({
      variables: { assetId },
    });

    if (response.data?.assetErrorTest === "OK") {
      await message.success("A test Asset Error has been triggered");
    } else {
      await message.error("Failed to run asset error test. Please try again.");
    }
  });

  return (
    <Tooltip title="Test Asset Error" placement="left">
      <FloatButton
        icon={loading ? <LoadingOutlined /> : <BugOutlined />}
        onClick={handleTest}
      />
    </Tooltip>
  );
};

export default AssetErrorTest;
